import { ToolbarItem } from './ReaderToolbar';

const TAB_ID_PREFIX = 'sidebar-item-';
const TAB_PANEL_ID_PREFIX = 'sidebar-content-';

export function getTabId(item: ToolbarItem) {
  return `${TAB_ID_PREFIX}${item.id}`;
}

export function parseItemId(controlId: string) {
  return controlId.split(TAB_ID_PREFIX)[1];
}

export function getTabPanelId(item: ToolbarItem) {
  return `${TAB_PANEL_ID_PREFIX}${item.id}`;
}
